export enum BtnLinkVariant {
    FILLED = 'filled',
    OUTLINED = 'outlined',
    TONAL = 'tonal',
}
